module.exports = __webpack_public_path__ + "static/media/cvc.79d045a6.svg";